module.exports = __webpack_public_path__ + "static/media/logo-owgi.fb1c1eab.svg";